import {FWU_TARGET_TYPES} from '../../consts/fwu/fwuTargetTypes';
import {selectDeviceData, selectHolderData} from '../../state/selectors/iotData';
import connectivityService from '../device/connectivityService';

const checkIfDeviceSupportsSblUpdate = (fwu_target) => {
    const isUsb = connectivityService.isUsb();

    if (isUsb) return true;

    const deviceAsset = selectDeviceData();
    const holderAsset = selectHolderData();

    const SBL_REQUIRED_VERSION_FOR_SBL_UPDATE_VIA_BLE = 6;

    switch (fwu_target) {
        case FWU_TARGET_TYPES.CHARGER_OR_MONO:
            return deviceAsset?.sblMajorVersion >= SBL_REQUIRED_VERSION_FOR_SBL_UPDATE_VIA_BLE;
        case FWU_TARGET_TYPES.MONO_ENGINE:
            return (
                deviceAsset?.sblMajorVersion >= SBL_REQUIRED_VERSION_FOR_SBL_UPDATE_VIA_BLE &&
                deviceAsset?.associatedDevices?.engine?.sblMajorVersion >= SBL_REQUIRED_VERSION_FOR_SBL_UPDATE_VIA_BLE
            );
        case FWU_TARGET_TYPES.HOLDER_DEVICE:
            if (!holderAsset) return false;

            return holderAsset?.sblMajorVersion >= SBL_REQUIRED_VERSION_FOR_SBL_UPDATE_VIA_BLE;
        case FWU_TARGET_TYPES.HOLDER_ENGINE:
            if (!holderAsset) return false;

            return (
                holderAsset?.sblMajorVersion >= SBL_REQUIRED_VERSION_FOR_SBL_UPDATE_VIA_BLE &&
                holderAsset?.associatedDevices?.engine?.sblMajorVersion >= SBL_REQUIRED_VERSION_FOR_SBL_UPDATE_VIA_BLE
            );
        default:
            return false;
    }
};

export default {
    checkIfDeviceSupportsSblUpdate,
};
